class installCalculator extends HTMLElement {
  constructor() {
    super();

    this.inputs = {
      tvScreen: this.querySelector('#calculatorTVScreenSize'),
      tvWeight: this.querySelector('#calculatorTVWeight'),
      vesaWidth: this.querySelector('#calculatorVESAWidth'),
      vesaHeight: this.querySelector('#calculatorVESAHeight'),
      wallSpaceHeight: this.querySelector('#calculatorWallSpaceHeight'),
      tvHeight: this.querySelector('#calculatorTVHeight'),
      mantelDepth: this.querySelector('#calculatorMantelDepth')
    }

    this.triggerCalcSection = document.querySelectorAll('[href="#spacsCalculator"]');

    this.calcParentEle = this.closest('[data-calculator-parent]');
    this.resultEle = document.querySelector('[data-calculator-result]');

    this.mountsData = [
      {
        "id": "mm815",
        "title": "MM815 Motorized Drop Down & Swivel TV Mount",
        "handle": "mm815-motorized-drop-down-swivel-tv-mount",
        "specs": {
          "screenSize": {
            "min": 45,
            "max": 90
          },
          "weight": {
            "min": 20,
            "max": 115
          },
          "vesa": {
            "width": {
              "min": 200,
              "max": 600
            },
            "height": {
              "min": 200,
              "max": 600
            }
          },
          "mantelDepth": {
            "max": 16
          }
        }
      },
      {
        "id": "MAX1",
        "title": "MM-MAX1 Full Motion TV Mount",
        "handle": "mm-max1-manual-full-motion-tv-mount",
        "specs": {
          "screenSize": {
            "min": 50,
            "max": 86,
          },
          "weight": {
            "min": 20,
            "max": 90,
          },
          "vesa": {
            "width": {
              "min": 100,
              "max": 600,
            },
            "height": {
              "min": 100,
              "max": 600,
            }
          },
          "mantelDepth": {
            "max": 20
          }
        }
      },
      {
        "id": "mm700",
        "title": "MM700 Pro Pull Down TV Mount",
        "handle": "mm700-premier-mount",
        "specs": {
          "screenSize": {
            "min": 45,
            "max": 90
          },
          "weight": {
            "min": 30,
            "max": 115
          },
          "vesa": {
            "width": {
              "min": 200,
              "max": 600
            },
            "height": {
              "min": 200,
              "max": 600
            }
          },
          "mantelDepth": {
            "max": 16
          }
        }
      },
      {
        "id": "mm720",
        "title": "MM720 Premier Pull Down TV Mount",
        "handle": "mm720-premier-mount",
        "specs": {
          "screenSize": {
            "min": 45,
            "max": 90
          },
          "weight": {
            "min": 30,
            "max": 115
          },
          "vesa": {
            "width": {
              "min": 200,
              "max": 600
            },
            "height": {
              "min": 200,
              "max": 600
            }
          },
          "mantelDepth": {
            "max": 16
          }
        }
      },
      {
        "id": "mm540",
        "title": "MM540 Enhanced Pull Down TV Mount",
        "handle": "mm540-enhanced-mount",
        "specs": {
          "screenSize": {
            "min": 44,
            "max": 80
          },
          "weight": {
            "min": 20,
            "max": 90
          },
          "vesa": {
            "width": {
              "min": 200,
              "max": 600
            },
            "height": {
              "min": 200,
              "max": 600
            }
          },
          "mantelDepth": {
            "max": 18
          }
        }
      },
      {
        "id": "mm340",
        "title": "MM340 Standard Pull Down TV Mount",
        "handle": "mm340-standard-mount",
        "specs": {
          "screenSize": {
            "min": 44,
            "max": 80
          },
          "weight": {
            "min": 20,
            "max": 90
          },
          "vesa": {
            "width": {
              "min": 200,
              "max": 600
            },
            "height": {
              "min": 200,
              "max": 600
            }
          },
          "mantelDepth": {
            "max": 18
          }
        }
      }
    ]

    this.mountsExtend = {
      "mountsExtend": {
        "mm340-standard-mount": {
          "badge": "Standard",
          "tagLine": "Lowest Price"
        },
        "mm-max1-manual-full-motion-tv-mount": {
					"badge": "MAX",
					"tagLine": "Enhanced Design",
				},
        "mm540-enhanced-mount": {
          "badge": "Enhanced",
          "tagLine": "Most Popular"
        },
        "mm700-premier-mount": {
          "badge": "Premier",
          "tagLine": "AWARD WINNER"
        },
        "mm720-premier-mount": {
          "badge": "Premier",
          "tagLine": "Best Seller"
        },
        "mm815-motorized-drop-down-swivel-tv-mount": {
          "badge": "Motorized",
          "tagLine": "Remote Controlled"
        }
      }
    }

    this.steps = this.querySelectorAll('.step');

    this.currentStep = 1;
    this.nextStepTriggers = this.querySelectorAll('[data-next-step]');
    this.prevStepTriggers = this.querySelectorAll('[data-prev-step]');

    this.usersInput = this.usersInput || {};
    this.acceptedMountsHandles = [];

  }

  connectedCallback() {
    this.nextStepTriggers.forEach(step => step.addEventListener('click', this.manageStep.bind(this)));
    this.prevStepTriggers.forEach(step => step.addEventListener('click', this.previousStep.bind(this)));
    this.triggerCalcSection?.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        let offset = 100;
        let elementPosition = this.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition - offset, behavior: "smooth" }); 
      })
    })
  }
  
  disconnectedCallback() {
    this.nextStepTriggers.forEach(step => step.addEventListener('click', this.manageStep.bind(this)));
    this.prevStepTriggers.forEach(step => step.addEventListener('click', this.previousStep.bind(this)));
  }
  
  manageStep(e) {
    e.preventDefault();
  
    let stepInputs = Array.from(this.querySelectorAll(`[data-step="${this.currentStep}"] input[type="number"]`));
    let inputsValidation = this.inputValidator(stepInputs);
  
    if (this.currentStep == 1 && this.querySelector('[name="hasMantel"]:checked').value == 'no' && inputsValidation) {
      this.currentStep = 3;
    }
  
    if (inputsValidation) {
      if (this.currentStep != 3) this.currentStep += 1;
      if (this.currentStep == 3) this.userInputs();
      this.renderStep();
      this.updateProgressBar();
    }
  }
  
  renderStep() {
    this.steps.forEach(step => {
      if (parseInt(step.dataset.step) === this.currentStep) {
        step.classList.add('active');
        document.querySelector('.space-calculator').scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        step.classList.remove('active');
      }
    });
  }
  
  previousStep(e) {
    e.preventDefault();
    this.currentStep -= 1;
    this.renderStep();
    this.updateProgressBar();
  }
  
  updateProgressBar() {
    if (this.currentStep === 3) return; 
    const totalSteps = this.steps.length; 
    const progressBar = this.querySelector('.progress');
    const progressPercentage = (this.currentStep / totalSteps) * 100;
  
    if (progressBar) {
      progressBar.style.width = `${progressPercentage}%`;
    }
  }
  

  userInputs() {
    Object.entries(this.inputs).forEach(([key, input]) => {
      if (input) this.usersInput[key] = input.type === 'checkbox' ? input.checked : input.value;
    });
    this.acceptedMounts();
    return this.usersInput;
  }

  inputValidator(inputs) {
    let allValid = true;

    Object.values(inputs).forEach(input => {
      if (input) {
        const value = parseFloat(input.value);
        const min = parseFloat(input.getAttribute('min'));
        const max = parseFloat(input.getAttribute('max'));
        let errorField = input.closest('.cal-group').querySelector('.error-msg');
        if (!isNaN(value)) {
          if ((min && value < min) || (max && value > max)) {
            if(errorField) errorField.classList.remove('d-none');
            document.querySelector('.space-calculator').scrollIntoView({ behavior: "smooth", block: "start" });
            allValid = false;
          } else {
            if(errorField) errorField.classList.add('d-none');
          }
        } else {
          if(errorField) errorField.classList.remove('d-none');
          document.querySelector('.space-calculator').scrollIntoView({ behavior: "smooth", block: "start" });
          allValid = false; 
        }
      }
    });
    return allValid;
  }

  acceptedMounts() {
    for (const mount in this.mountsData) {
      if (Object.hasOwnProperty.call(this.mountsData, mount)) {
        const element = this.mountsData[mount];

        let mountAccepted = true;
        let ms = element.specs;
        let vSpace = this.calcVSpace(element.id,this.usersInput.mantelDepth,this.usersInput.tvHeight);
        
        //screen size
        if (!this.withinRange(Number(this.usersInput.tvScreen),ms.screenSize.min,ms.screenSize.max)) mountAccepted = false;
        
        //weight
		if (!this.withinRange(Number(this.usersInput.tvWeight),ms.weight.min,ms.weight.max)) mountAccepted = false;

		//vesa
		if (!this.withinRange(Number(this.usersInput.vesaWidth),ms.vesa.width.min,ms.vesa.width.max)) mountAccepted = false;
		if (!this.withinRange(Number(this.usersInput.vesaHeight),ms.vesa.height.min,ms.vesa.height.max)) mountAccepted = false;

        // Step 2
        if (this.querySelector('[name="hasMantel"]:checked').value == 'yes') {
          //mantel depth
          if (Number(this.usersInput.mantelDepth) > ms.mantelDepth.max) mountAccepted = false;
  
          //vertical space calculation
          if (vSpace == false) mountAccepted = false;
  
          //vertical space needs to be <= to the wall space height
          if (vSpace !== false && vSpace > this.usersInput.wallSpaceHeight) mountAccepted = false;
        }

        if (mountAccepted) this.acceptedMountsHandles.push(element.handle);
      }
    }
    this.randerData(this.acceptedMountsHandles);
  }

  calcVSpace(id, mDepth, tvHeight) {
    let depth = Number(mDepth),
      height = Number(tvHeight),
      vSpace = false;

    switch (id) {
      case "mm340":
        vSpace =
          depth < 9
            ? height + 4
            : depth >= 9 && depth < 11
            ? height + 5
            : depth >= 11 && depth < 14
            ? height + 6
            : depth >= 14 && depth <= 18
            ? height + 8
            : false;

        break;
      case "MAX1":
        vSpace =
          depth < 21
            ? height + 4
            : false;
        break;
      case "mm540":
        vSpace =
          depth < 9
            ? height + 4
            : depth >= 9 && depth < 11
            ? height + 5
            : depth >= 11 && depth < 14
            ? height + 6
            : depth >= 14 && depth <= 18
            ? height + 8
            : false;

        break;
      case "mm700":
        vSpace =
          depth < 8
            ? height + 2
            : depth >= 8 && depth < 10
            ? height + 4
            : depth >= 10 && depth < 12
            ? height + 6
            : depth >= 12 && depth <= 15
            ? height + 9
            : depth == 16
            ? height + 11
            : false;

        break;
        case "mm720":
        vSpace =
          depth < 8
            ? height + 2
            : depth >= 8 && depth < 10
            ? height + 4
            : depth >= 10 && depth < 12
            ? height + 6
            : depth >= 12 && depth <= 15
            ? height + 9
            : depth == 16
            ? height + 11
            : false;

        break;
      case "mm815":
        vSpace =
          depth < 8
            ? height + 3
            : depth >= 8 && depth < 10
            ? height + 5
            : depth >= 10 && depth < 12
            ? height + 6
            : depth >= 12 && depth < 14
            ? height + 7
            : depth >= 14 && depth <= 16
            ? height + 9
            : false;

        break;
      default:
        return;
    }

    return vSpace;
  }

  withinRange(val, min, max) {
    let result = val >= min && val <= max ? true : false;
    return result;
  }

  resetCalcualtor() {
    let resetBtn = document.querySelector('[data-reset-calculator]');
    resetBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      
      this.calcParentEle.classList.add('active');
      this.resultEle.classList.remove('active');

      this.currentStep = 1;
      this.renderStep();
      this.updateProgressBar();
    })
  }

  randerData = async (handles) => {
    let product_handles = handles;
    if (product_handles.length < 1) {
      product_handles = 'no-results';
    }
    await fetch(`${location.pathname}?section_id=component-calculator-results&handles=${product_handles}`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      this.calcParentEle.classList.remove('active');

      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-component-calculator-results').innerHTML;
      this.resultEle.innerHTML = resultsMarkup;
      this.loadReviews();
      this.resultEle.classList.add('active');
      document.querySelector('.space-calculator').scrollIntoView({ behavior: "smooth", block: "start" });
      this.resetCalcualtor();
      this.acceptedMountsHandles = [];
    })
    .catch((error) => {
        if (error?.code === 20) {
            // Code 20 means the call was aborted
            return;
        }
        throw error;
    });
  }

  loadReviews() {
    // Ensure reviews are loaded after a short delay
    setTimeout(() => {
      if (typeof yotpoWidgetsContainer !== 'undefined') {
        yotpoWidgetsContainer.initWidgets(false).then((result) => {
          console.log('Yotpo Widgets Initialized Successfully:', result);
        }).catch((error) => {
          console.error('Error Initializing Yotpo Widgets:', error);
        });
      } else {
        console.error('Yotpo Widgets Container is not defined.');
      }
    }, 500);
    let quickShopModal = document.querySelector('quick-shop');
    if(quickShopModal && typeof quickShopModal.updateEvents == 'function') quickShopModal.updateEvents(); 
  }
}

customElements.define('install-calculator', installCalculator);